"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutPaymentSection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PaymentMethodToggle = require("./PaymentMethodToggle");
var _BillingInfoForm = require("./BillingInfoForm");
var _ApplePayButton = require("./ApplePayButton");
var _PaymentErrorMessage = require("./PaymentErrorMessage");
var _BoostReferralInput = require("./BoostReferralInput");
var _boostPricingHelpers = require("../boostPricingHelpers");
var _CheckBoxLabel = require("./CheckBoxLabel");
var _Checkbox = require("../../common/Checkbox");
var _chargebeeApi = require("../../../api/chargebeeApi");
var _material = require("@mui/material");
var _utils = require("../../../utils");
var _GooglePayButton = require("./GooglePayButton");
var _consts = require("../../../consts");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// --------------------------------------
// Types & Interfaces
// --------------------------------------

// --------------------------------------
// Styles
// --------------------------------------
var customInputStyle = "flex-1 border border-neutral-400 rounded-md p-4 shadow";
var CardPlaceholders = function CardPlaceholders(_ref) {
  var onReady = _ref.onReady;
  var containerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (containerRef.current) {
      // The <div> placeholders are now in the DOM
      onReady === null || onReady === void 0 || onReady(containerRef.current);
    }
  }, [onReady]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef,
    id: "card-element",
    className: "mt-4 flex flex-col space-y-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "cb-card-number",
    className: customInputStyle
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "cb-card-expiry",
    className: customInputStyle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "cb-card-cvv",
    className: customInputStyle
  })));
};

// --------------------------------------
// Main Component
// --------------------------------------
var CheckoutPaymentSection = exports.CheckoutPaymentSection = function CheckoutPaymentSection(_ref2) {
  var _ref2$email = _ref2.email,
    email = _ref2$email === void 0 ? "" : _ref2$email,
    productTerm = _ref2.productTerm,
    productTier = _ref2.productTier,
    errorMessageRef = _ref2.errorMessageRef,
    referral = _ref2.referral,
    setReferral = _ref2.setReferral,
    promotionCredit = _ref2.promotionCredit,
    promotionPercentOff = _ref2.promotionPercentOff,
    setPromotionCredit = _ref2.setPromotionCredit,
    setPromotionPercentOff = _ref2.setPromotionPercentOff,
    onPaymentSucceed = _ref2.onPaymentSucceed,
    onPaymentInitiated = _ref2.onPaymentInitiated;
  // const { hideExitPopup } = usePopup();
  var cardComponentRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)("card"),
    _useState2 = _slicedToArray(_useState, 2),
    paymentMethod = _useState2[0],
    setPaymentMethod = _useState2[1];
  var _useQueryParamsAsJson = (0, _utils.useQueryParamsAsJson)(['email', 'tier', 'term']),
    capturedUrlParams = _useQueryParamsAsJson.capturedUrlParams; // ignore saving email, tier, term as its redundant

  // Apple Pay / Payment Intents
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    cbLoading = _useState4[0],
    setCbLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = _slicedToArray(_useState5, 2),
    paymentIntentLoading = _useState6[0],
    setPaymentIntentLoading = _useState6[1]; // reserved for card payment intent
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    applePayButtonLoading = _useState8[0],
    setApplePayButtonLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    googlePayButtonLoading = _useState10[0],
    setGooglePayButtonLoading = _useState10[1];
  // const [renderCustomButton, setRenderCustomButton] = useState(true);
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isApplePayEligible = _useState12[0],
    setIsApplePayEligible = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isGooglePayEligible = _useState14[0],
    setIsGooglePayEligible = _useState14[1];
  var _useState15 = (0, _react.useState)(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    applePayHandler = _useState16[0],
    setApplePayHandler = _useState16[1];
  var _useState17 = (0, _react.useState)(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    googlePayHandler = _useState18[0],
    setGooglePayHandler = _useState18[1];
  var _useState19 = (0, _react.useState)(undefined),
    _useState20 = _slicedToArray(_useState19, 2),
    applePayPI = _useState20[0],
    setApplePayPI = _useState20[1];
  var _useState21 = (0, _react.useState)(undefined),
    _useState22 = _slicedToArray(_useState21, 2),
    googlePayPI = _useState22[0],
    setGooglePayPI = _useState22[1];
  var _useState23 = (0, _react.useState)(undefined),
    _useState24 = _slicedToArray(_useState23, 2),
    cardPI = _useState24[0],
    setCardPI = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    termsAccepted = _useState26[0],
    setTermsAccepted = _useState26[1];

  // for comparing apple pay pi update
  var previousApplePayPI = (0, _utils.usePrevious)(applePayPI);
  var previousGooglePayPI = (0, _utils.usePrevious)(googlePayPI);

  // Form state
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    promoLoading = _useState28[0],
    setPromoLoading = _useState28[1];
  var _useState29 = (0, _react.useState)(false),
    _useState30 = _slicedToArray(_useState29, 2),
    paymentProcessing = _useState30[0],
    setPaymentProcessing = _useState30[1];
  var _useState31 = (0, _react.useState)(""),
    _useState32 = _slicedToArray(_useState31, 2),
    paymentError = _useState32[0],
    setPaymentError = _useState32[1];
  var _useState33 = (0, _react.useState)(""),
    _useState34 = _slicedToArray(_useState33, 2),
    firstName = _useState34[0],
    setFirstName = _useState34[1];
  var _useState35 = (0, _react.useState)(""),
    _useState36 = _slicedToArray(_useState35, 2),
    lastName = _useState36[0],
    setLastName = _useState36[1];
  var _useState37 = (0, _react.useState)(""),
    _useState38 = _slicedToArray(_useState37, 2),
    city = _useState38[0],
    setCity = _useState38[1];
  var _useState39 = (0, _react.useState)("State"),
    _useState40 = _slicedToArray(_useState39, 2),
    state = _useState40[0],
    setState = _useState40[1];
  var _useState41 = (0, _react.useState)(""),
    _useState42 = _slicedToArray(_useState41, 2),
    zipcode = _useState42[0],
    setZipcode = _useState42[1];
  var _useState43 = (0, _react.useState)(""),
    _useState44 = _slicedToArray(_useState43, 2),
    formError = _useState44[0],
    setFormError = _useState44[1];
  var _useState45 = (0, _react.useState)(false),
    _useState46 = _slicedToArray(_useState45, 2),
    promoValid = _useState46[0],
    setPromoValid = _useState46[1];
  var _useState47 = (0, _react.useState)(""),
    _useState48 = _slicedToArray(_useState47, 2),
    promoMessage = _useState48[0],
    setPromoMessage = _useState48[1];
  var formCompleted = !!firstName && !!lastName && !!city && !!state && state !== "State" && !!zipcode;
  var zipCodeValidated = /^\d{5}$/.test(zipcode);

  // Button states
  var cardDisabled = !zipCodeValidated || !termsAccepted || paymentProcessing || promoLoading || paymentIntentLoading || paymentMethod !== "card";
  var applePayDisabled = !termsAccepted || paymentMethod !== "apple_pay";
  var googlePayDisabled = !termsAccepted || paymentMethod !== "google_pay";

  // If there's a formError or T&C not accepted, we cannot mount Apple Pay's native button

  // --------------------------------------
  // Payment success handler
  // --------------------------------------
  var handlePaymentSucceed = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
      var paymentIntent, additionalData, paymentSource, createSubscriptionRes, _ref5, invoiceId, code, amount;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            paymentIntent = _ref3.paymentIntent, additionalData = _ref3.additionalData, paymentSource = _ref3.paymentSource;
            _context.next = 3;
            return (0, _chargebeeApi.createSubscription)({
              email: email,
              intent: paymentIntent,
              productTerm: productTerm,
              productTier: productTier,
              promoOrReferralCode: referral,
              additionalData: additionalData,
              capturedUrlParams: capturedUrlParams
            });
          case 3:
            createSubscriptionRes = _context.sent;
            _ref5 = createSubscriptionRes || {}, invoiceId = _ref5.invoiceId, code = _ref5.code, amount = _ref5.amount;
            if (code) {
              // callback function on payment succeed, such as tracking
              if (typeof onPaymentSucceed === "function") {
                onPaymentSucceed({
                  invoiceId: invoiceId,
                  amount: amount,
                  paymentSource: paymentSource,
                  code: code
                });
              }
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(),
  // re-run if any of the below change to ensure current state
  [referral, email, productTerm, productTier, onPaymentSucceed]);

  // --------------------------------------
  // Payment initiated handler
  // --------------------------------------
  var handlePaymentInitiated = (0, _react.useCallback)(function (paymentSource) {
    if (typeof onPaymentInitiated === "function") {
      var piAmount = paymentSource === "card" && (cardPI === null || cardPI === void 0 ? void 0 : cardPI.amount) || paymentSource === "apple_pay" && (applePayPI === null || applePayPI === void 0 ? void 0 : applePayPI.amount) || paymentSource === "google_pay" && (googlePayPI === null || googlePayPI === void 0 ? void 0 : googlePayPI.amount) || null;
      var amount = (piAmount || 0) / 100;
      if (amount === undefined || amount === null) {
        var _boostProductTierConf;
        // cardPI does not exist; calculate price using config
        var _ref6 = ((_boostProductTierConf = _consts.boostProductTierConfig_v3[productTerm]) === null || _boostProductTierConf === void 0 ? void 0 : _boostProductTierConf[productTier]) || {},
          originalPrice = _ref6.price;
        amount = (0, _utils.calculatePriceAfterPromotion)(originalPrice, promotionPercentOff, promotionCredit);
      }

      // for tracking such as braze
      onPaymentInitiated({
        tier: productTier,
        term: productTerm,
        promoCode: referral,
        amount: amount,
        paymentSource: paymentSource
      });
    }
  }, [onPaymentInitiated, cardPI, applePayPI, googlePayPI, productTerm, productTier, promotionPercentOff, promotionCredit, referral]);

  // --------------------------------------
  // Card payment submission
  // --------------------------------------
  var handleCardPayment = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var additionalData, authorizedCardPI;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (cardComponentRef.current) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            if (!(paymentProcessing || promoLoading || paymentIntentLoading || paymentMethod !== "card")) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            if (formCompleted) {
              _context2.next = 7;
              break;
            }
            setFormError("Please fill out all fields");
            return _context2.abrupt("return");
          case 7:
            if (zipCodeValidated) {
              _context2.next = 10;
              break;
            }
            setFormError("Please enter a valid zipcode");
            return _context2.abrupt("return");
          case 10:
            setPaymentError("");
            setPaymentProcessing(true);

            // trigger checkout start callback
            handlePaymentInitiated("card");
            _context2.prev = 13;
            if (cardComponentRef.current) {
              _context2.next = 16;
              break;
            }
            throw new Error("Chargebee is not initialized");
          case 16:
            if (cardPI) {
              _context2.next = 18;
              break;
            }
            throw new Error("Unable to process payment");
          case 18:
            additionalData = {
              email: email,
              billingAddress: {
                firstName: firstName,
                lastName: lastName,
                city: city,
                state: state,
                countryCode: "US",
                zip: zipcode
              }
            };
            _context2.next = 21;
            return cardComponentRef.current.authorizeWith3ds(cardPI, additionalData);
          case 21:
            authorizedCardPI = _context2.sent;
            if (!((authorizedCardPI === null || authorizedCardPI === void 0 ? void 0 : authorizedCardPI.status) === "authorized")) {
              _context2.next = 27;
              break;
            }
            _context2.next = 25;
            return handlePaymentSucceed({
              paymentIntent: authorizedCardPI,
              additionalData: additionalData,
              paymentSource: "card"
            });
          case 25:
            _context2.next = 28;
            break;
          case 27:
            throw new Error("Payment authorization failed");
          case 28:
            _context2.next = 33;
            break;
          case 30:
            _context2.prev = 30;
            _context2.t0 = _context2["catch"](13);
            setPaymentError(_context2.t0.message);
          case 33:
            _context2.prev = 33;
            setPaymentProcessing(false);
            return _context2.finish(33);
          case 36:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[13, 30, 33, 36]]);
    }));
    return function handleCardPayment() {
      return _ref7.apply(this, arguments);
    };
  }();

  // --------------------------------------
  // Apple Pay mount
  // --------------------------------------
  var mountApplePayButtonWithCallback = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          setApplePayButtonLoading(true);
          if (applePayHandler) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return");
        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return applePayHandler.mountPaymentButton("#apple-pay-button", {
            buttonColor: "black",
            buttonType: "plain",
            // requestPayerEmail: true,
            requestBilling: true
          });
        case 6:
          setApplePayButtonLoading(false);
          _context4.next = 9;
          return applePayHandler.handlePayment({
            success: function () {
              var _success = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(result) {
                var paymentIntent, _ref9, billingAddress, additionalData;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      paymentIntent = result.paymentIntent;
                      _ref9 = (paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.payer_info) || {}, billingAddress = _ref9.billing_address;
                      /* 
                        "billing_address": {
                          "firstName",
                          "lastName",
                          "addressLine1",
                          "addressLine2",
                          "zip",
                          "stateCode",
                          "city",
                          "countryCode": "US",
                          "country": "United States"
                        },
                      */
                      additionalData = {
                        email: email,
                        billingAddress: billingAddress
                      };
                      _context3.prev = 3;
                      _context3.next = 6;
                      return handlePaymentSucceed({
                        paymentIntent: paymentIntent,
                        additionalData: additionalData,
                        paymentSource: "apple_pay"
                      });
                    case 6:
                      _context3.next = 12;
                      break;
                    case 8:
                      _context3.prev = 8;
                      _context3.t0 = _context3["catch"](3);
                      console.error("Error handling post payment operation", _context3.t0);
                      setPaymentError("Payment unsuccessful");
                    case 12:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3, null, [[3, 8]]);
              }));
              function success(_x2) {
                return _success.apply(this, arguments);
              }
              return success;
            }(),
            error: function error(err) {
              console.error("Apple Pay error", err);
              setPaymentError(err.message || "Payment unsuccessful");
            }
          });
        case 9:
          _context4.next = 16;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](3);
          console.error("Error mounting Apple Pay button:", _context4.t0);
          setIsApplePayEligible(false);
          setApplePayHandler(undefined);
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 11]]);
  })), [
  // re-run if either applePayHandler or handlePaymentSucceed changes
  applePayPI,
  // Include referral as a dependency
  applePayHandler, email, firstName, lastName, city, state, zipcode, handlePaymentSucceed]);

  // --------------------------------------
  // Google Pay mount
  // --------------------------------------
  var mountGooglePayButtonWithCallback = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          setGooglePayButtonLoading(true);
          if (googlePayHandler) {
            _context6.next = 3;
            break;
          }
          return _context6.abrupt("return");
        case 3:
          _context6.prev = 3;
          _context6.next = 6;
          return googlePayHandler.mountPaymentButton("#gpay-button", {
            buttonColor: "black",
            buttonType: "plain",
            buttonSizeMode: "fill"
          }, {
            requestBillingAddress: true
          });
        case 6:
          setGooglePayButtonLoading(false);
          _context6.next = 9;
          return googlePayHandler.handlePayment({
            success: function () {
              var _success2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(result) {
                var paymentIntent, _ref11, billingAddress, additionalData;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      paymentIntent = result.paymentIntent;
                      _ref11 = (paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.payer_info) || {}, billingAddress = _ref11.billing_address;
                      additionalData = {
                        email: email,
                        billingAddress: {
                          firstName: billingAddress.firstName,
                          lastName: billingAddress.lastName,
                          // city, // not available in billingAddress
                          // state, // not available in billingAddress
                          countryCode: billingAddress.countryCode,
                          zip: billingAddress.zip
                        }
                      };
                      _context5.prev = 3;
                      _context5.next = 6;
                      return handlePaymentSucceed({
                        paymentIntent: paymentIntent,
                        additionalData: additionalData,
                        paymentSource: "google_pay"
                      });
                    case 6:
                      _context5.next = 12;
                      break;
                    case 8:
                      _context5.prev = 8;
                      _context5.t0 = _context5["catch"](3);
                      console.error("Error handling post payment operation", _context5.t0);
                      setPaymentError("Payment unsuccessful");
                    case 12:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5, null, [[3, 8]]);
              }));
              function success(_x3) {
                return _success2.apply(this, arguments);
              }
              return success;
            }(),
            error: function error(err) {
              // do not log payment_intent errors
              if (err.object !== "payment_intent") {
                console.error("Google Pay error", err);
                setPaymentError(err.message || "Payment unsuccessful");
              }
            }
          });
        case 9:
          _context6.next = 14;
          break;
        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](3);
          // if payment failed google pay will remount with error
          console.error("Error mounting Google Pay button:", _context6.t0);
        case 14:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[3, 11]]);
  })), [
  // re-run if either applePayHandler or handlePaymentSucceed changes
  googlePayPI,
  // Include referral as a dependency
  googlePayHandler, email, firstName, lastName, city, state, zipcode, handlePaymentSucceed]);

  // --------------------------------------
  // Payment Intents (both card & apple pay)
  // --------------------------------------
  var updateApplePayIntent = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(promoOrReferralCode) {
      var _yield$getPaymentInte, applePayIntent;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            // unset applePayButtonLoading will be done in mountApplePayButtonWithCallback useEffect
            setApplePayButtonLoading(true);
            _context7.prev = 1;
            _context7.next = 4;
            return (0, _chargebeeApi.getPaymentIntent)({
              email: email,
              productTier: productTier,
              productTerm: productTerm,
              promoOrReferralCode: promoOrReferralCode,
              paymentMethodType: "apple_pay",
              capturedUrlParams: capturedUrlParams
            });
          case 4:
            _yield$getPaymentInte = _context7.sent;
            applePayIntent = _yield$getPaymentInte.paymentIntent;
            if (!applePayIntent) {
              _context7.next = 10;
              break;
            }
            setApplePayPI(applePayIntent);
            // this will trigger apple pay button to re-mount
            _context7.next = 10;
            return applePayHandler.updatePaymentIntent(applePayIntent);
          case 10:
            _context7.next = 16;
            break;
          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](1);
            console.error("Error fetching Apple Pay Payment Intents:", _context7.t0);
            setFormError(formError || _context7.t0.message || "Server Error");
          case 16:
            _context7.prev = 16;
            setApplePayButtonLoading(false);
            return _context7.finish(16);
          case 19:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[1, 12, 16, 19]]);
    }));
    return function updateApplePayIntent(_x4) {
      return _ref12.apply(this, arguments);
    };
  }();
  var updateGooglePayIntent = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(promoOrReferralCode) {
      var _yield$getPaymentInte2, googlePayIntent;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            // unset googlePayButtonLoading will be done in mountGooglePayButtonWithCallback useEffect
            setGooglePayButtonLoading(true);
            _context8.prev = 1;
            _context8.next = 4;
            return (0, _chargebeeApi.getPaymentIntent)({
              email: email,
              productTier: productTier,
              productTerm: productTerm,
              promoOrReferralCode: promoOrReferralCode,
              paymentMethodType: "google_pay",
              capturedUrlParams: capturedUrlParams
            });
          case 4:
            _yield$getPaymentInte2 = _context8.sent;
            googlePayIntent = _yield$getPaymentInte2.paymentIntent;
            if (!googlePayIntent) {
              _context8.next = 10;
              break;
            }
            setGooglePayPI(googlePayIntent);
            // this will trigger google pay button to re-mount
            _context8.next = 10;
            return googlePayHandler.updatePaymentIntent(googlePayIntent);
          case 10:
            _context8.next = 16;
            break;
          case 12:
            _context8.prev = 12;
            _context8.t0 = _context8["catch"](1);
            console.error("Error fetching Google Pay Payment Intents:", _context8.t0);
            setFormError(formError || _context8.t0.message || "Server Error");
          case 16:
            _context8.prev = 16;
            setGooglePayButtonLoading(false);
            return _context8.finish(16);
          case 19:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 12, 16, 19]]);
    }));
    return function updateGooglePayIntent(_x5) {
      return _ref13.apply(this, arguments);
    };
  }();
  var _fetchPaymentIntents = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(promoOrReferralCode) {
      var _yield$getPaymentInte3, cardPaymentIntent, discount, _ref15, valid, reason, type, _ref15$credit, credit;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            setPaymentIntentLoading(true);
            setPromoLoading(!!promoOrReferralCode);
            _context9.next = 5;
            return (0, _chargebeeApi.getPaymentIntent)({
              email: email,
              productTier: productTier,
              productTerm: productTerm,
              promoOrReferralCode: promoOrReferralCode,
              paymentMethodType: "card",
              capturedUrlParams: capturedUrlParams
            });
          case 5:
            _yield$getPaymentInte3 = _context9.sent;
            cardPaymentIntent = _yield$getPaymentInte3.paymentIntent;
            discount = _yield$getPaymentInte3.discount;
            if (!(promoOrReferralCode && discount)) {
              _context9.next = 19;
              break;
            }
            _ref15 = discount || {}, valid = _ref15.valid, reason = _ref15.reason, type = _ref15.type, _ref15$credit = _ref15.credit, credit = _ref15$credit === void 0 ? 0 : _ref15$credit;
            if (!(valid === false)) {
              _context9.next = 16;
              break;
            }
            setPromoValid(false);
            setPromoMessage(reason || "Invalid promo code ".concat(promoOrReferralCode));
            // Reset payment intent with no referral code
            _context9.next = 15;
            return _fetchPaymentIntents("");
          case 15:
            return _context9.abrupt("return");
          case 16:
            // Handle valid promo code
            setPromoValid(true);
            setReferral(promoOrReferralCode);
            if (type === "FIXED") {
              setPromotionCredit(credit / 100);
            } else if (type === "PERCENT_OFF") {
              setPromotionPercentOff(credit);
            } else if (type === "SPECIAL") {
              setPromoMessage("Promo code ".concat(promoOrReferralCode, " applied"));
            }
          case 19:
            if (cardPaymentIntent) {
              _context9.next = 21;
              break;
            }
            return _context9.abrupt("return");
          case 21:
            setCardPI(cardPaymentIntent);
            _context9.next = 28;
            break;
          case 24:
            _context9.prev = 24;
            _context9.t0 = _context9["catch"](0);
            setFormError(_context9.t0.message || "Server Error");
            return _context9.abrupt("return");
          case 28:
            _context9.prev = 28;
            setPromoLoading(false);
            setPaymentIntentLoading(false);
            return _context9.finish(28);
          case 32:
            if (!(isApplePayEligible && applePayHandler && applePayPI)) {
              _context9.next = 35;
              break;
            }
            _context9.next = 35;
            return updateApplePayIntent(promoOrReferralCode);
          case 35:
            if (!(isGooglePayEligible && googlePayHandler && googlePayPI)) {
              _context9.next = 38;
              break;
            }
            _context9.next = 38;
            return updateGooglePayIntent(promoOrReferralCode);
          case 38:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[0, 24, 28, 32]]);
    }));
    return function fetchPaymentIntents(_x6) {
      return _ref14.apply(this, arguments);
    };
  }();

  // --------------------------------------
  // Initialize card fields
  // --------------------------------------
  var initializeChargebeeCard = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var cb, cardComponent;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (window.Chargebee) {
            _context10.next = 3;
            break;
          }
          console.warn("Chargebee script is not loaded!");
          return _context10.abrupt("return");
        case 3:
          _context10.prev = 3;
          cb = window.Chargebee.getInstance();
          _context10.next = 7;
          return cb.load("components");
        case 7:
          cardComponent = cb.createComponent("card");
          cardComponent.createField("number", {
            placeholder: "Card number"
          }).at("#cb-card-number");
          cardComponent.createField("expiry", {
            placeholder: "MM / YY"
          }).at("#cb-card-expiry");
          cardComponent.createField("cvv", {
            placeholder: "CVV"
          }).at("#cb-card-cvv");

          // Mount the entire card instance into the parent container
          // you can pass the same "#card-element" or a different ID, if desired
          cardComponent.mount("#card-element");

          // Save reference for later (3DS or authorizeWith3ds)
          cardComponentRef.current = cardComponent;

          // Done loading
          _context10.next = 18;
          break;
        case 15:
          _context10.prev = 15;
          _context10.t0 = _context10["catch"](3);
          console.error("Error initializing Chargebee:", _context10.t0);
        case 18:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[3, 15]]);
  })), []);

  // --------------------------------------
  // Mobile Pay eligibility check
  // --------------------------------------
  var checkApplePayEligibility = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var _handler$supportsAppl, _handler$canMakePayme, cb, handler, isSupported;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          if (window.Chargebee) {
            _context11.next = 2;
            break;
          }
          return _context11.abrupt("return");
        case 2:
          _context11.prev = 2;
          cb = window.Chargebee.getInstance();
          _context11.next = 6;
          return cb.load("apple-pay");
        case 6:
          handler = _context11.sent;
          isSupported = !!((_handler$supportsAppl = handler.supportsApplePay) !== null && _handler$supportsAppl !== void 0 && _handler$supportsAppl.call(handler) && (_handler$canMakePayme = handler.canMakePayments) !== null && _handler$canMakePayme !== void 0 && _handler$canMakePayme.call(handler));
          if (isSupported) {
            setIsApplePayEligible(true);
            setApplePayHandler(handler);
          }
          _context11.next = 15;
          break;
        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](2);
          console.error("Error checking Apple Pay eligibility:", _context11.t0);
          setIsApplePayEligible(false);
        case 15:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[2, 11]]);
  })), []);
  var checkGooglePayEligibility = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var cb, handler;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          if (window.Chargebee) {
            _context12.next = 2;
            break;
          }
          return _context12.abrupt("return");
        case 2:
          _context12.prev = 2;
          cb = window.Chargebee.getInstance();
          _context12.next = 6;
          return cb.load("google-pay");
        case 6:
          handler = _context12.sent;
          // unable to detect google pay eligible; assume true
          setIsGooglePayEligible(true);
          setGooglePayHandler(handler);
          _context12.next = 15;
          break;
        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](2);
          console.error("Error checking Google Pay eligibility:", _context12.t0);
          setIsGooglePayEligible(false);
        case 15:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[2, 11]]);
  })), []);

  // --------------------------------------
  // Handle Apple Pay custom button click
  // --------------------------------------
  var handleCustomButtonClicked = function handleCustomButtonClicked(e) {
    e.preventDefault();
    if (!termsAccepted) {
      setFormError("Please accept terms and conditions");
      return;
    }
  };

  // --------------------------------------
  // Effects
  // --------------------------------------
  // on initial mount, check apple pay and google pay eligible and get card intent
  (0, _react.useEffect)(function () {
    if (!cbLoading) {
      // early exit as cb already loaded
      return;
    }
    var initialize = /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return Promise.all([checkApplePayEligibility(), checkGooglePayEligibility(), _fetchPaymentIntents(referral)]);
            case 3:
              _context13.next = 8;
              break;
            case 5:
              _context13.prev = 5;
              _context13.t0 = _context13["catch"](0);
              console.error("checkout initialization error:", _context13.t0);
            case 8:
              _context13.prev = 8;
              setCbLoading(false);
              return _context13.finish(8);
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[0, 5, 8, 11]]);
      }));
      return function initialize() {
        return _ref19.apply(this, arguments);
      };
    }();

    // run initialize if chargebee is already available
    if (window.Chargebee) {
      initialize();
      return;
    }

    // listener for chargebee becoming available
    var checkForChargebee = setInterval(function () {
      if (window.Chargebee) {
        initialize();
        clearInterval(checkForChargebee);
      }
    }, 100);
    return function () {
      return clearInterval(checkForChargebee);
    };
  }, [cbLoading]);

  // on applePayPI update, remount apple pay button
  (0, _react.useEffect)(function () {
    if (applePayPI && applePayPI !== previousApplePayPI) {
      mountApplePayButtonWithCallback();
    }
  }, [applePayPI, mountApplePayButtonWithCallback]);

  // on googlePayPI update, remount google pay button
  (0, _react.useEffect)(function () {
    if (googlePayPI && googlePayPI !== previousGooglePayPI) {
      mountGooglePayButtonWithCallback();
    }
  }, [googlePayPI, mountGooglePayButtonWithCallback]);

  // mount the button if user selected apple_pay for the first time, and apple pay handler is loaded
  (0, _react.useEffect)(function () {
    var handleLoadApplePayComponent = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _yield$getPaymentInte4, newApplePayPI;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return (0, _chargebeeApi.getPaymentIntent)({
                email: email,
                productTier: productTier,
                productTerm: productTerm,
                promoOrReferralCode: referral,
                paymentMethodType: "apple_pay",
                capturedUrlParams: capturedUrlParams
              });
            case 2:
              _yield$getPaymentInte4 = _context14.sent;
              newApplePayPI = _yield$getPaymentInte4.paymentIntent;
              if (!newApplePayPI) {
                _context14.next = 8;
                break;
              }
              setApplePayPI(newApplePayPI);
              _context14.next = 8;
              return applePayHandler.setPaymentIntent(newApplePayPI);
            case 8:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function handleLoadApplePayComponent() {
        return _ref20.apply(this, arguments);
      };
    }();
    if (isApplePayEligible && applePayHandler && paymentMethod === "apple_pay" && !applePayPI) {
      handleLoadApplePayComponent();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isApplePayEligible, applePayHandler, paymentMethod]);

  // mount the button if user selected google_pay for the first time, and google pay handler is loaded
  (0, _react.useEffect)(function () {
    var handleLoadGooglePayComponent = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _yield$getPaymentInte5, newGooglePayPI;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return (0, _chargebeeApi.getPaymentIntent)({
                email: email,
                productTier: productTier,
                productTerm: productTerm,
                promoOrReferralCode: referral,
                paymentMethodType: "google_pay",
                capturedUrlParams: capturedUrlParams
              });
            case 2:
              _yield$getPaymentInte5 = _context15.sent;
              newGooglePayPI = _yield$getPaymentInte5.paymentIntent;
              if (!newGooglePayPI) {
                _context15.next = 8;
                break;
              }
              setGooglePayPI(newGooglePayPI);
              _context15.next = 8;
              return googlePayHandler.setPaymentIntent(newGooglePayPI);
            case 8:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function handleLoadGooglePayComponent() {
        return _ref21.apply(this, arguments);
      };
    }();
    if (isGooglePayEligible && googlePayHandler && paymentMethod === "google_pay" && !googlePayPI) {
      handleLoadGooglePayComponent();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGooglePayEligible, googlePayHandler, paymentMethod]);

  // --------------------------------------
  // Render
  // --------------------------------------
  if (cbLoading) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mx-auto py-5 px-2 text-center"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "fas fa-spinner text-white fa-spin"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-white p-5 rounded-lg"
  }, /*#__PURE__*/_react["default"].createElement(_material.Stack, {
    spacing: 1,
    className: "text-black"
  }, /*#__PURE__*/_react["default"].createElement(_PaymentMethodToggle.PaymentMethodToggle, {
    paymentMethod: paymentMethod,
    setPaymentMethod: setPaymentMethod,
    isApplePayEligible: isApplePayEligible,
    isGooglePayEligible: isGooglePayEligible
  }), /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": paymentMethod === "card",
    timeout: "auto",
    unmountOnExit: false,
    sx: {
      mt: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "border border-neutral-400 rounded-md p-4"
  }, /*#__PURE__*/_react["default"].createElement(_BillingInfoForm.BillingInfoForm, {
    firstName: firstName,
    lastName: lastName,
    city: city,
    state: state,
    zipcode: zipcode,
    setFirstName: setFirstName,
    setLastName: setLastName,
    setCity: setCity,
    setState: setState,
    setZipcode: setZipcode,
    setFormError: setFormError
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-4 text-blue-600 font-bold"
  }, "Card Info"), /*#__PURE__*/_react["default"].createElement(CardPlaceholders, {
    onReady: initializeChargebeeCard
  }))), /*#__PURE__*/_react["default"].createElement(_BoostReferralInput.BoostReferralInput, {
    email: email,
    referral: referral,
    setReferral: setReferral,
    promoValid: promoValid
    // setPromoValid={setPromoValid}
    ,
    promoMessage: promoMessage,
    setPromoMessage: setPromoMessage,
    setPromotionCredit: setPromotionCredit,
    setPromotionPercentOff: setPromotionPercentOff,
    productTerm: productTerm,
    productTier: productTier,
    promoLoading: promoLoading,
    applyPromoCode: function applyPromoCode(updatedCode) {
      _fetchPaymentIntents(updatedCode);
    }
  }), /*#__PURE__*/_react["default"].createElement(_boostPricingHelpers.OrderSummary, {
    productTerm: productTerm,
    productTier: productTier,
    promotionCredit: promotionCredit,
    promotionPercentOff: promotionPercentOff
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    labelComponent: /*#__PURE__*/_react["default"].createElement(_CheckBoxLabel.CheckBoxLabel, {
      term: productTerm
    }),
    labelClassName: "text-sm text-black",
    checked: termsAccepted,
    onChange: function onChange(e) {
      setTermsAccepted(e.target.checked);
      setFormError("");
    }
  }), formError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-error-500 text-sm flex justify-center"
  }, formError), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: paymentMethod === "card" ? "block" : "none"
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    disabled: cardDisabled,
    id: "submit",
    onClick: handleCardPayment,
    className: "".concat(cardDisabled ? "bg-gray-secondary" : "bg-green-primary hover:bg-opacity-75", " rounded-lg w-full p-4 leading-none text-white text-xl font-semibold self-center mt-2"),
    style: {
      outline: "none",
      minWidth: 220,
      boxShadow: "rgb(86 45 100 / 15%) 13px 11px 36px -10px"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    id: "button-submit"
  }, paymentProcessing ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-spinner text-black fa-spin"
  }) : "Submit"))), isApplePayEligible && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-2 ".concat(paymentMethod === "apple_pay" ? "flex justify-center items-center" : "hidden")
  }, /*#__PURE__*/_react["default"].createElement(_ApplePayButton.ApplePayButton, {
    applePayButtonLoading: applePayButtonLoading,
    renderCustomButton: applePayDisabled,
    handleCustomButtonClicked: handleCustomButtonClicked,
    onPaymentInitiated: function onPaymentInitiated() {
      return handlePaymentInitiated("apple_pay");
    }
  })), isGooglePayEligible && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: paymentMethod === "google_pay" ? "block" : "none"
    }
  }, /*#__PURE__*/_react["default"].createElement(_GooglePayButton.GooglePayButton, {
    googlePayButtonLoading: googlePayButtonLoading,
    renderCustomButton: googlePayDisabled,
    handleCustomButtonClicked: handleCustomButtonClicked,
    onPaymentInitiated: function onPaymentInitiated() {
      return handlePaymentInitiated("google_pay");
    }
  })), /*#__PURE__*/_react["default"].createElement(_PaymentErrorMessage.PaymentErrorMessage, {
    paymentError: paymentError,
    errorMessageRef: errorMessageRef
  })));
};